import { useParams } from "react-router-dom";

export const Surgeons = () => {
  const { id } = useParams();
  const path = `/newsletter/versions/${id}.html`;
  return (
    <iframe
      sandbox="allow-scripts"
      title={"Surgeons"}
      src={path}
      style={{ width: "100vw", height: "100vh" }}
    />
  );
};
